import { useLazyQuery } from '@apollo/client';
import React, { useContext, useEffect } from 'react'
import { GET_STRIPE_TRANSFER_ERROR } from '../../../features/ErrorDashboard/api/ErrorQuery';
import ToasterWithMessage from '../toaster';
import { CircularProgress } from '@mui/material';
import styles from './StripePaymentsError.module.css';
import AppTable from '../table/AppTable';
import moment from 'moment';
import { formatDates } from '../../../helper';
import { globalContext } from '../../../Provider/AppProvider';


const StripePaymentsError = (props: any) => {
  const {
          rowsPerPageStripe,
          currentPageStripe,
          setCurrentPageStripe,
          checking,
          setChecking,
          stripePaymentsErrorList,
          setStripePaymentsErrorList,
          columnTypes,
          setColumnTypes,
          sortType,
          setSortType,
          selected,
          setSelected,
          datesForApiCall,
          selectedStartDate,
          selectedEndDate,
          GenerateStripePaymentsErrorHeadCells,
          handleChangeRowsPerPageStripe,
          handlePageChangeStripe,

  } = props;
  const {error} = ToasterWithMessage();
  const {globalState} = useContext<any>(globalContext)

  const [getStripePaymentsErrorData,{loading}] = useLazyQuery(GET_STRIPE_TRANSFER_ERROR,{
    fetchPolicy: 'no-cache',
    onCompleted: (stripeData) => {
      setStripePaymentsErrorList(stripeData);
      const tempState = {...globalState};
      tempState.soldTickets.errorcount = stripeData?.stripe_errors_aggregate?.aggregate?.count
    },
    onError: (err) => {
      error("Something went wrong while fetching error data!")
    }
  })


  const callStripePaymentsErrorApi = () => {
    const startdateForStripe = datesForApiCall.fromdate
    const enddateForStripe = datesForApiCall.enddate
    // const payloadEndDateForStripe = moment(datesForApiCall.enddate,'YYYY-MM-DD').add(1,'days');
    const formattedDates = formatDates(startdateForStripe, enddateForStripe);
    if(moment(startdateForStripe).isSameOrBefore(enddateForStripe,'day')){
      if(globalState?.soldTickets?.failed){
        getStripePaymentsErrorData({
          variables: {
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate,
            limit: rowsPerPageStripe,
            offset: (currentPageStripe -1)*rowsPerPageStripe,
            order_by: (columnTypes === 'u_full_name') || (columnTypes === 'u_email_id') 
                    ? {user: {[columnTypes]: sortType} } 
                    : (columnTypes === 'e_name') || (columnTypes === 'e_date')
                      ? {payment_transaction: {ticket: {event: {[columnTypes] : sortType}}}}
                      : {[columnTypes]: sortType},
            email : globalState?.soldTickets?.emailId
          }
        })
      }else {
        getStripePaymentsErrorData({
          variables: {
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate,
            limit: rowsPerPageStripe,
            offset: (currentPageStripe -1)*rowsPerPageStripe,
            order_by: (columnTypes === 'u_full_name') || (columnTypes === 'u_email_id') 
                    ? {user: {[columnTypes]: sortType} } 
                    : (columnTypes === 'e_name') || (columnTypes === 'e_date')
                      ? {payment_transaction: {ticket: {event: {[columnTypes] : sortType}}}}
                      : {[columnTypes]: sortType},
          }
        })
      }
        return;
    }else {
        // error("Fromdate must be less than todate");
        return;
    }
  };
  
  useEffect(() => {
    callStripePaymentsErrorApi();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedStartDate,
     selectedEndDate,
     sortType,
     columnTypes,
     rowsPerPageStripe,
     currentPageStripe,
     globalState.globalSearch.searchtext
    ]);


  return (
    <>
      {
        loading
      ?
        <div className={styles.TableCircularProgress}>
        <CircularProgress color="primary" size={35} />
        </div>
      :
      <AppTable
        handleChangeRowsPerPage={handleChangeRowsPerPageStripe}
        handlePageChange={handlePageChangeStripe}
        setColumnTypes={setColumnTypes}
        sortType={sortType}
        setSortType={setSortType}
        setChecking={setChecking}
        checking={checking}
        rowsPerPage={rowsPerPageStripe}
        setCurrentPage={setCurrentPageStripe}
        currentPage={currentPageStripe}
        list={stripePaymentsErrorList}
        // list={dummyStripeErrorData}
        tableTitle="stripePaymentsError"
        selected={selected}
        setSelected={setSelected}
        generateHeadCells={GenerateStripePaymentsErrorHeadCells}
      />
      }
    </>
  )
}

export default StripePaymentsError